import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime, transformFeedback } from 'utils/Formatters';

const AccountPlayerPlaysRow = ({ data }) => {
  return (
    <tr>
      <td>{data.playpackTitle}</td>
      <td>{data.cardTitle}</td>
      <td>{formatDateTime(data.createdAt)}</td>
      <td>{transformFeedback(data.feedbackLiked)}</td>
      <td>{transformFeedback(data.feedbackLevel)}</td>
      <td>{data.feedbackText}</td>
    </tr>
  );
}

AccountPlayerPlaysRow.propTypes = {
  data: PropTypes.object.isRequired,
}

export default AccountPlayerPlaysRow;
